import React, { useEffect, useRef, useState, } from 'react'
import { Link, useHistory, } from 'react-router-dom';
import HtmlParser from 'react-html-parser';
import $ from 'jquery';

import ReCAPTCHA from 'react-google-recaptcha';

import axios from 'axios';
import useAuth from '../../controllers/users/useAuth';

import {
    responseGet, globalSettings, globalSettingsPassword, styles, validateEmail, validatePhoneNumber,
    sendMessageCloseCurrentWindowAsync, languageObjGet,
    isUndNullEmp,
    awaitDelay
} from '../../helpers/settings';
import { GlobalFormats } from '../../classes/main/globalFormats';

import RegisterUserMessage from './RegisterUserMessage';
import Menu from '../main/Menu';

const currentMethod = 'currentMethod';

export default function RegisterUser({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result = {};
    let dataObj = {};

    const formDataDefaultValues = () => {
        return {
            firstName: '',
            lastName: '',
            phoneNumber: '',
            email: '',
            password: '',
            passwordConfirm: '',
            contractId: '',
        };
    }

    const auth = useAuth()
    const history = useHistory();
    const [formData, setFormData] = useState(formDataDefaultValues());
    const [errorFirstName, setErrorFirstName] = useState('');
    const [errorLastName, setErrorLastName] = useState('');
    const [errorPhoneNumber, setErrorPhoneNumber] = useState('');
    const [errorEmail, setErrorEmail] = useState('');
    const [errorPassword, setErrorPassword] = useState('');
    const [errorPasswordConfirm, setErrorPasswordConfirm] = useState('');
    const [errorContractId, setErrorContractId] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showRegisterMessage, setShowRegisterMessage] = useState(false);
    const [userLocal, setUserLocal] = useState({});
    const recaptchaRef = useRef(ReCAPTCHA);
    const urlStop = '#nothing';
    const controls = {
        buttons: {
            send: {
                className: 'btn btn-outline-primary mx-1',
                id: 'btnSend',
            },
            home: {
                className: 'btn btn-outline-success',
                id: 'btnHome',
            },
            login: {
                className: 'btn btn-outline-primary mx-1',
                id: 'btnLogin',
            },
        },
        icons: {
            send: {
                id: 'iconSend',
                className: globalSettings?.icons?.save,
            },
            home: {
                id: 'iconHome',
                className: globalSettings?.icons?.home,
            },
            login: {
                id: 'iconLogin',
                className: globalSettings?.icons?.powerOff,
            },
        },
        inputs: {
            firstName: {
                id: 'inputFirstName',
            },
            lastName: {
                id: 'inputLastName',
            },
            phoneNumber: {
                id: 'inputPhoneNumber',
            },
            contract: {
                id: 'inputContract',
            },
            email: {
                id: 'inputEmail',
            },
            password: {
                id: 'inputPassword',
            },
            passwordConfirm: {
                id: 'inputPasswordConfirm',
            },
        },
        spinners: {
            send: {
                id: 'spSend',
                className: '',
            },
            home: {
                id: 'spHome',
                className: '',
            },
            login: {
                id: 'spLogin',
                className: '',
            },
        },
        urls: {
            forgotYourPassword: {
                id: 'urlForgotYourPassword',
                className: 'btn-link',
            },
            reCaptchaPrivaciConditions: {
                id: 'urlReCaptchaPrivaciConditions',
                className: '',
            },
            registerStatus: {
                id: 'urlStatusRegister',
                className: '',
            },
        },
    };
    //#endregion variables

    //#region methods
    const registerUserPostAsync = async (e) => {
        const currentMethod = 'registerUserPostAsync';
        let response = responseGet();
        try {
            e.preventDefault();

            //#region variables
            //let localRecaptchaToken = {};
            //#endregion variables

            //#region check form data
            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion check form data

            await controlsStatusSetAsync({processType: 1, subMethod: currentMethod,});
            //sendMessage(2, globalSettings?.messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

            //#region get recaptcha token
            const recaptchaToken = await recaptchaRef.current.executeAsync();
            recaptchaRef?.current?.reset();
            //#endregion get recaptcha token

            //#region create account
            dataObj = {
                contractId: formData?.contractId,
                displayName: `${formData?.firstName}, ${formData?.lastName}`,
                email: formData?.email,
                firstName: formData?.firstName,
                lastName: formData?.lastName,
                phoneNumber: formData?.phoneNumber,
                password: formData?.password,
                passwordConfirm: formData?.passwordConfirm,
                recaptchaToken: recaptchaToken,
                languageId: languageObj?.id,
            };

            result = await axios?.post(
                `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlAccounts}/nTnR${globalSettings?.app?.backend?.urlUserRegister}`,
                dataObj
            );
            response = result.data;

            if (!response?.isSuccess || response?.isWarning) {
                await controlsStatusSetAsync({processType: 0, subMethod: currentMethod,}); 
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }

            setUserLocal(formData);
            setFormData(formDataDefaultValues());
            setShowRegisterMessage(true);
            //sendMessage(-2, '', 0, false, false, null, '');
            await controlsStatusSetAsync({processType: 0, subMethod: currentMethod,}); 
            //#endregion create account
        } catch (ex) {
            await controlsStatusSetAsync({processType: 0, subMethod: currentMethod,}); 
            response.msgType = -1;
            response.msgText = `Method: ${currentMethod}<br/>`
            response.msgText += `Error: ${ex?.message}`
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return response;
        }
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            response = await errorsDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            setShowPassword(false);

            if (isUndNullEmp({ data: formData?.firstName, subMethod: currentMethod })?.result) {
                setErrorFirstName(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            if (isUndNullEmp({ data: formData?.lastName, subMethod: currentMethod })?.result) {
                setErrorLastName(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            if (isUndNullEmp({ data: formData?.phoneNumber, subMethod: currentMethod })?.result) {
                setErrorPhoneNumber(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            if (!validatePhoneNumber({ phoneNumber: formData?.phoneNumber, })) {
                setErrorPhoneNumber(globalSettings?.messages?.youMustEnterValidPhoneNumber?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: formData?.contractId, subMethod: currentMethod })?.result) {
                setErrorContractId(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (formData?.contractId?.length !== globalSettings?.contracts?.length) {
                setErrorContractId(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: formData?.email, subMethod: currentMethod })?.result) {
                setErrorEmail(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            if (!validateEmail({ email: formData?.email })) {
                setErrorEmail(globalSettings?.messages?.youMustEnterValidEmail?.[languageObj?.id]);
                response.isWarning = true;
            }
            if (isUndNullEmp({ data: formData?.password, subMethod: currentMethod })?.result) {
                setErrorPassword(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            if (formData?.password?.length < globalSettingsPassword?.minLength) {
                setErrorPassword(`${globalSettings?.messages?.youMustEnterValidPassword?.[languageObj?.id]} ${globalSettings?.messages?.passwordMinimunCharacters?.[languageObj?.id]}`);
                response.isWarning = true;
            }
            if (isUndNullEmp({ data: formData?.passwordConfirm, subMethod: currentMethod })?.result) {
                setErrorPasswordConfirm(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            if (formData?.passwordConfirm?.length < globalSettingsPassword?.minLength) {
                setErrorPasswordConfirm(`${globalSettings?.messages?.youMustEnterValidPasswordConfirm?.[languageObj?.id]} ${globalSettings?.messages?.passwordMinimunCharacters?.[languageObj?.id]}`);
                response.isWarning = true;
            }
            if (!isUndNullEmp({ data: formData?.password, subMethod: currentMethod })?.result &&
                !isUndNullEmp({ data: formData?.passwordConfirm, subMethod: currentMethod })?.result) {
                if (formData?.password?.length >= globalSettingsPassword?.minLength && formData?.passwordConfirm?.length >= globalSettingsPassword?.minLength) {
                    if (formData?.password !== formData?.passwordConfirm) {
                        setErrorPasswordConfirm(globalSettings?.messages?.passwordAndPasswordConfirmNotMatch?.[languageObj?.id]);
                        response.isWarning = true;
                    }
                }
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errorsDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errorsDefaultSetAsync';
        let response = responseGet();
        try {
            setErrorFirstName('');
            setErrorLastName('');
            setErrorPhoneNumber('');
            setErrorContractId('');
            setErrorEmail('');
            setErrorPassword('');
            setErrorPasswordConfirm('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            if (auth?.isLoged()) {
                history.push('/');
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const buttonsProcessAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'buttonsProcessAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e?.preventDefault, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            switch (e?.currentTarget?.id) {
                case controls?.buttons?.home?.id:
                    await controlsStatusSetAsync({ processType: 2, subMethod: currentMethod, });
                    //await new Promise((resolve) => setTimeout(resolve, 1000));
                    await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                    window.location.href = globalSettings?.app?.backend?.urlHome;
                    break;
                case controls?.buttons?.login?.id:
                    await controlsStatusSetAsync({ processType: 3, subMethod: currentMethod, });
                    //await new Promise((resolve) => setTimeout(resolve, 1000));
                    await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                    window.location.href = globalSettings?.app?.backend?.urlLogin;
                    break;
                default:
                    await controlsStatusSetAsync({ processType: 0, subMethod: currentMethod, });
                    break;
            }
        } catch (ex) {
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const controlsStatusSetAsync = async ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.icons?.send?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.send?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.send?.id}`)?.removeClass();

                    $(`#${controls?.icons?.home?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.home?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.home?.id}`)?.removeClass();

                    $(`#${controls?.icons?.login?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.login?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.login?.id}`)?.removeClass();

                    $(`#${controls?.icons?.send?.id}`)?.addClass(controls?.icons?.send?.className);
                    $(`#${controls?.buttons?.send?.id}`)?.addClass(controls?.buttons?.send?.className);
                    $(`#${controls?.spinners?.send?.id}`)?.addClass(controls?.spinners?.send?.className);

                    $(`#${controls?.icons?.home?.id}`)?.addClass(controls?.icons?.home?.className);
                    $(`#${controls?.buttons?.home?.id}`)?.addClass(controls?.buttons?.home?.className);
                    $(`#${controls?.spinners?.home?.id}`)?.addClass(controls?.spinners?.home?.className);

                    $(`#${controls?.icons?.login?.id}`)?.addClass(controls?.icons?.login?.className);
                    $(`#${controls?.buttons?.login?.id}`)?.addClass(controls?.buttons?.login?.className);
                    $(`#${controls?.spinners?.login?.id}`)?.addClass(controls?.spinners?.login?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.login?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.send?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.send.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.home?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.home.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.icons?.login?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.login?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            $(`#${controls?.inputs?.firstName?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.lastName?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.phoneNumber?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.contract?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.passwordConfirm?.id}`).attr('readOnly', (processType !== 0));
            
            $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            //$(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
                'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
                'target': (processType !== 0 ? '' : '_blank'),
            });

            if (processType !== 0) {
                $(`#${controls?.buttons?.send?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.home?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.login?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            console.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'onLoad - view' });
    }, [])// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            <Menu viewName='home' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{globalSettings?.labels?.registerNewMembership?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    {/*<li className='breadcrumb-item'><a href='#'>Home</a></li>*/}
                                    <li className='breadcrumb-item'><Link to='/'>{globalSettings?.labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{globalSettings?.labels?.registerNewMembership?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {!showRegisterMessage ?

                            <div className='login-box' style={styles?.loginBox}>

                                <div className='card card-primary card-outline shadow-lg'>

                                    {/*Header*/}
                                    <div className='card-header'>
                                        <h5><img src={globalSettings?.images?.userLogin} alt='userLogin' style={styles?.cardHeaderLogo} /> - {globalSettings?.labels?.registry?.[languageObj?.id]}</h5>
                                    </div>

                                    <form onSubmit={(e) => registerUserPostAsync(e)} method='post'>

                                        {/*Body*/}
                                        <div className='card-body'>

                                            <div>{globalSettings?.labels?.personalInformation?.[languageObj?.id]}:</div>
                                            <hr />

                                            <div className='form-group'>
                                                <div className='input-group mb-3'>
                                                    <input id={controls?.inputs?.firstName?.id}
                                                        type='text'
                                                        className='form-control'
                                                        placeholder={globalSettings?.labels?.firstName?.[languageObj?.id]}
                                                        onChange={(e) => setFormData({ ...formData, 'firstName': e?.target?.value, })}
                                                        onFocus={() => setErrorFirstName('')}
                                                        value={formData.firstName}
                                                        tooltip='tooltip'
                                                        title={globalSettings?.labels?.firstName?.[languageObj?.id]} />
                                                    <div className='input-group-append'>
                                                        <div className='input-group-text'>
                                                            <span className='fas fa-user' />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorFirstName)}</div>
                                            </div>

                                            <div className='form-group'>
                                                <div className='input-group mb-3'>
                                                    <input id={controls?.inputs?.lastName?.id}
                                                        type='text'
                                                        className='form-control'
                                                        placeholder={globalSettings?.labels?.lastName?.[languageObj?.id]}
                                                        onChange={(e) => setFormData({ ...formData, 'lastName': e?.target?.value, })}
                                                        onFocus={() => setErrorLastName('')}
                                                        value={formData.lastName}
                                                        tooltip='tooltip'
                                                        title={globalSettings?.labels?.lastName?.[languageObj?.id]} />
                                                    <div className='input-group-append'>
                                                        <div className='input-group-text'>
                                                            <span className='fas fa-user' />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorLastName)}</div>
                                            </div>

                                            <div className='form-group'>
                                                <div className='input-group mb-3'>
                                                    <input id={controls?.inputs?.phoneNumber?.id}
                                                        type='text'
                                                        className='form-control'
                                                        placeholder={globalSettings?.labels?.phoneNumber?.[languageObj?.id]}
                                                        onChange={(e) => setFormData({ ...formData, 'phoneNumber': e?.target?.value, })}
                                                        onFocus={() => setErrorPhoneNumber('')}
                                                        value={formData.phoneNumber}
                                                        tooltip='tooltip'
                                                        title={globalSettings?.labels?.phoneNumber?.[languageObj?.id]} />
                                                    <div className='input-group-append'>
                                                        <div className='input-group-text'>
                                                            <span className='fas fa-mobile-alt prefix grey-text' />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorPhoneNumber)}</div>
                                            </div>

                                            <div>{globalSettings?.labels?.accountInformation?.[languageObj?.id]}:</div>
                                            <hr />

                                            <div className='form-group'>
                                                <div className='input-group mb-3'>
                                                    <input id={controls?.inputs?.contract?.id}
                                                        type='text'
                                                        className='form-control'
                                                        minLength={globalSettings?.contracts?.length}
                                                        maxLength={globalSettings?.contracts?.length}
                                                        placeholder={globalSettings?.labels?.contract?.[languageObj?.id]}
                                                        onChange={(e) => setFormData({ ...formData, 'contractId': e?.target?.value, })}
                                                        onFocus={() => setErrorContractId('')}
                                                        value={formData.contractId}
                                                        tooltip='tooltip'
                                                        title={globalSettings?.labels?.contract?.[languageObj?.id]} />
                                                    <div className='input-group-append'>
                                                        <div className='input-group-text'>
                                                            <span className={`${globalSettings?.icons?.fileInvoice} prefix grey-text`} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorContractId)}</div>
                                            </div>

                                            <div className='form-group'>
                                                <div className='input-group mb-3'>
                                                    <input id={controls?.inputs?.email?.id}
                                                        type='text'
                                                        className='form-control'
                                                        placeholder={globalSettings?.labels?.email?.[languageObj?.id]}
                                                        onChange={(e) => setFormData({ ...formData, 'email': e?.target?.value, })}
                                                        onFocus={() => setErrorEmail('')}
                                                        value={formData.email}
                                                        tooltip='tooltip'
                                                        title={globalSettings?.labels?.email?.[languageObj?.id]} />
                                                    <div className='input-group-append'>
                                                        <div className='input-group-text'>
                                                            <span className={`${globalSettings?.icons?.envelope} prefix grey-text`} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorEmail)}</div>
                                            </div>

                                            <div className='form-group'>
                                                <div className='input-group mb-3'>
                                                    <input id={controls?.inputs?.password?.id}
                                                        className='form-control'
                                                        onChange={(e) => setFormData({ ...formData, 'password': e?.target?.value, })}
                                                        onFocus={() => setErrorPassword('')}
                                                        value={formData.password}
                                                        type={showPassword ? 'text' : 'password'}
                                                        placeholder={globalSettings?.labels?.password?.[languageObj?.id]}
                                                        tooltip='tooltip'
                                                        title={globalSettings?.labels?.password?.[languageObj?.id]} />
                                                    <div className='input-group-append'>
                                                        <div className='input-group-text' type='button'>
                                                            <span className={showPassword ? globalSettings?.icons?.eyeIpasswordIpassword : globalSettings?.icons?.eyeSlashIpasswordIpassword}
                                                                onClick={() => setShowPassword(!showPassword)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorPassword)}</div>
                                            </div>

                                            <div className='form-group'>
                                                <div className='input-group mb-3'>
                                                    <input id={controls?.inputs?.passwordConfirm?.id}
                                                        className='form-control'
                                                        onChange={(e) => setFormData({ ...formData, 'passwordConfirm': e?.target?.value, })}
                                                        onFocus={() => setErrorPasswordConfirm('')}
                                                        value={formData.passwordConfirm}
                                                        type={showPassword ? 'text' : 'password'}
                                                        placeholder={globalSettings?.labels?.confirmPassword?.[languageObj?.id]}
                                                        tooltip='tooltip'
                                                        title={globalSettings?.labels?.confirmPassword?.[languageObj?.id]} />
                                                    <div className='input-group-append'>
                                                        <div className='input-group-text' type='button'>
                                                            <span className={showPassword ? globalSettings?.icons?.eyeIpasswordIpassword : globalSettings?.icons?.eyeSlashIpasswordIpassword}
                                                                onClick={() => setShowPassword(!showPassword)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(errorPasswordConfirm)}</div>
                                            </div>

                                            <div>
                                                {/* <i className={globalSettings?.icons?.lock} />{' '}<Link to={globalSettings?.app?.backend?.urlForgotPassword} className='btn-link'>{globalSettings?.labels?.forgotYourPassword?.[languageObj?.id]}</Link> */}
                                                <i className={globalSettings?.icons?.lock} />{' '}<a id={controls?.urls?.forgotYourPassword?.id} href={globalSettings?.app?.backend?.urlForgotPassword} className='btn-link'>{globalSettings?.labels?.forgotYourPassword?.[languageObj?.id]}</a>
                                            </div>
                                            <div>
                                                {/* <i className={globalSettings?.icons?.userClock} />{' '}<Link to={globalSettings?.app?.backend?.urlRegisterStatus} className='btn-link'>{globalSettings?.labels?.checkRegistrationStatus}</Link> */}
                                                <i className={globalSettings?.icons?.userClock} />{' '}<a id={controls?.urls?.registerStatus?.id} href={globalSettings?.app?.backend?.urlRegisterStatus} className='btn-link'>{globalSettings?.labels?.checkRegistrationStatus?.[languageObj?.id]}</a>
                                            </div>
                                        </div>

                                        {/*Footer*/}
                                        <div className='card-footer'>
                                            <div className='form-group text-right'>
                                                <button id={controls?.buttons?.send?.id}
                                                    tooltip='tooltip'
                                                    title={globalSettings?.labels?.send?.[languageObj?.id]}
                                                    data-toggle='tooltip'
                                                    type='submit'
                                                    className={controls?.buttons?.send?.className}>
                                                    <i id={controls?.icons?.send?.id} className={controls?.icons?.send?.className} /> <span id={controls?.spinners?.send?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.buttons?.home?.id}
                                                    tooltip='tooltip'
                                                    title={globalSettings?.labels?.home?.[languageObj?.id]}
                                                    data-toggle='tooltip'
                                                    type='button'
                                                    onClick={(e) => buttonsProcessAsync({ e: e, subMethod: e?.currentTarget?.id, })}
                                                    className={controls?.buttons?.home?.className}>
                                                    <i id={controls?.icons?.home?.id} className={controls?.icons?.home?.className} /> <span id={controls?.spinners?.home?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.buttons?.login?.id}
                                                    tooltip='tooltip'
                                                    title={globalSettings?.labels?.login?.[languageObj?.id]}
                                                    data-toggle='tooltip'
                                                    type='button'
                                                    onClick={(e) => buttonsProcessAsync({ e: e, subMethod: e?.currentTarget?.id, })}
                                                    className={controls?.buttons?.login?.className}>
                                                    <i id={controls?.icons?.login?.id} className={controls?.icons?.login?.className} /> <span id={controls?.spinners?.login?.id} className='' aria-hidden='true'></span>
                                                </button>
                                            </div>
                                        </div>
                                    </form>

                                    <div hidden>
                                        <ReCAPTCHA id={controls?.urls?.reCaptchaPrivaciConditions?.id}
                                            className='g-recaptcha'
                                            ref={recaptchaRef}
                                            sitekey={globalSettings?.app?.reCAPTCHA?.reCAPTCHASiteKey}
                                            size='invisible'
                                        />
                                    </div>
                                </div>

                                <div className='text-muted text-center text-small'>
                                    <p>
                                        <small>{globalSettings?.labels?.protectedByReCAPTCHA?.[languageObj?.id]} - <a target='_blank' href={globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions} rel='noreferrer'>{globalSettings?.labels?.privacyAndConditions?.[languageObj?.id]}</a></small>
                                    </p>
                                </div>
                            </div>

                            : <RegisterUserMessage user={userLocal} />}

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}
            </div>
        </div>
    )
}